import { render, staticRenderFns } from "./ConcernElementsModal.vue?vue&type=template&id=6d497844&"
import script from "./ConcernElementsModal.vue?vue&type=script&lang=js&"
export * from "./ConcernElementsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports